import { render, staticRenderFns } from "./vip-banner.vue?vue&type=template&id=77dd3a46&scoped=true&"
import script from "./vip-banner.vue?vue&type=script&lang=js&"
export * from "./vip-banner.vue?vue&type=script&lang=js&"
import style0 from "./vip-banner.vue?vue&type=style&index=0&id=77dd3a46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dd3a46",
  null
  
)

export default component.exports